"use strict";

exports.env_handshake = process.env.HANDSHAKE_ENV;
exports.external_address = process.env.EXTERNAL_ADDRESS;
exports.external_domain = process.env.EXTERNAL_FQDN;
exports.apple_audience = process.env.APPLE_SIGNIN_AUDIENCE_WWW;
exports.google_maps_browser_key = process.env.GOOGLE_MAPS_BROWSER_KEY;
exports.segment_io_api_key = process.env.SEGMENT_IO_API_KEY;
exports.forter_key = process.env.FORTER_SNIPPET_KEY;
exports.search_size = 30;
exports.migration_on = 'true' === process.env.MIGRATION_ON;
exports.hideReferral = false;
exports.intercom_app_id = process.env.INTERCOM_APP_ID;
exports.branch_sdk_key = process.env.BRANCH_SDK_KEY;